/*!
 * Copyright (c) HSO.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import {
    IBuyboxAddToCartViewProps,
    IBuyboxAddToOrderTemplateViewProps,
    IBuyboxAddToWishlistViewProps,
    IBuyboxCallbacks,
    IBuyboxData,
    IBuyboxFindInStoreViewProps,
    IBuyboxKeyInPriceViewProps,
    IBuyboxProductConfigureDropdownViewProps,
    IBuyboxProductConfigureViewProps,
    IBuyboxProductQuantityViewProps,
    IBuyboxProps,
    IBuyboxShopSimilarLookViewProps,
    IBuyboxState,
    IBuyboxViewProps
} from '@msdyn365-commerce-modules/buybox';
import { PriceComponent } from '@msdyn365-commerce/components';
import { IncrementalQuantity, ITelemetryContent, Module, Node } from '@msdyn365-commerce-modules/utilities';
import { StringExtensions, ArrayExtensions, getProductPageUrlSync } from '@msdyn365-commerce-modules/retail-actions';
import { AttributeValue, SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import * as Msdyn365 from '@msdyn365-commerce/core';
import React, { useState } from 'react';
import {
    IBuyboxProps as IBuyboxExtentionProps,
    IBuyboxResources as IBuyboxExtentionResources
} from '../definition-extensions/buybox.ext.props.autogenerated';
import { IBuyboxData as IBuyboxExtentionData } from './buybox.data';
import { IPopupProps, Popup } from './hsoCustomPopup';

const BuyboxView: React.FC<IBuyboxViewProps & IBuyboxExtentionProps<IBuyboxExtentionData>> = props => {
    const {
        data: {
            product: { result: product },
            productAvailableQuantity: { result: productAvailableQuantity },
        }
    } = props;
    props.data.popUpClass = 'noshow-popupclass';
    props.data.shouldRenderPopUpAlternateProduct = false;
    debugger;
    if (product && props.config.enableAlternateProductRedirect) {
        let useAltItem: number =
            (product &&
                product.ExtensionProperties &&
                product.ExtensionProperties?.some(ep => {
                    return ep.Key?.startsWith('USEALTITEMID');
                }) &&
                ArrayExtensions.firstOrDefault(product.ExtensionProperties?.filter(ep => {
                    return ep.Key?.startsWith('USEALTITEMID');
                }))?.Value?.IntegerValue) ||
            0;

        let altItem: number =
            (product &&
                product.ExtensionProperties &&
                product.ExtensionProperties?.some(ep => {
                    return ep.Key?.startsWith('ALTPRODUCT');
                }) &&
                ArrayExtensions.firstOrDefault(product.ExtensionProperties?.filter(ep => {
                    return ep.Key?.startsWith('ALTPRODUCT');
                }))?.Value?.LongValue) ||
            0;

        if (useAltItem > 0 && altItem > 0) {
            debugger;
            let isProductAvailable: boolean = (productAvailableQuantity && productAvailableQuantity.length > 0 && ArrayExtensions.firstOrDefault(productAvailableQuantity)?.IsProductAvailable) || false;
            let productUrl: string = product && getProductPageUrlSync(product?.Name || '', altItem, props.context.actionContext, undefined);
            if (useAltItem === 1 && !isProductAvailable) {
                props.data.navigationToAlternateProduct = productUrl;
                props.data.popUpClass = 'show-popupclass';
                props.data.shouldRenderPopUpAlternateProduct = true;
                return _renderView(props);
            } else if (useAltItem === 2) {
                props.data.navigationToAlternateProduct = productUrl;
                props.data.popUpClass = 'show-popupclass';
                props.data.shouldRenderPopUpAlternateProduct = true;
                return _renderView(props);
            } else {
                return _renderView(props);
            }
        } else {
            return _renderView(props);
        }
    } else {
        return _renderView(props);
    }
};

const _renderView = (props: IBuyboxViewProps & IBuyboxExtentionProps<IBuyboxExtentionData>) => {
    const {
        ModuleProps,
        MediaGalleryContainerProps,
        ProductInfoContainerProps,
        addToCart,
        addToOrderTemplate,
        addToWishlist,
        telemetryContent,
        configure,
        description,
        findInStore,
        quantity,
        title,
        rating,
        callbacks,
        state,
        resources,
        inventoryLabel,
        shopSimilarLook,
        keyInPrice,
        quantityLimitsMessages,
        max,
        shopSimilarDescription,
        unitOfMeasure,
        productComparisonButton,
    } = props;

    const {
        data: {
            product: { result: product },
            productSpecificationData: { result: productSpecificationData }
        }
    } = props;

    const [modalOpen, setModalOpen] = useState(props.data.shouldRenderPopUpAlternateProduct);
    let PopupProps: IPopupProps= {
        dialogStrings: {
            message: props.config.alternateProductText!,
            buttonMessage: resources.redirectButtonText
        },
        className:'closePopUp',
        navigationUrl: props.data.navigationToAlternateProduct,
        modalOpen,
        setModalOpen,
        context: props.context,
        typeName: props.typeName,
        id: props.id,
        data: {product}
    }
    const _redirectToAlternateProduct = (event: React.MouseEvent<HTMLButtonElement>): void => {
        window.location.assign(event.currentTarget.name);
        console.log(event.currentTarget.name);
    }

    return (
        <>
            {Popup(PopupProps)}
            <div className={props.data.popUpClass}>
                <Node
                    key='popUpRedirect'
                    className='closePopUp'
                    name={props.data.navigationToAlternateProduct}
                    onClick={_redirectToAlternateProduct}
                >
                    {resources.redirectButtonText}
                </Node>
            </div>
            <Module {...ModuleProps}>
                <Node {...MediaGalleryContainerProps}>{props.mediaGallery}</Node>
                <Node {...ProductInfoContainerProps}>
                    {title}
                    {_renderProductNumber(props, product)}
                    {_renderProductPrice(props, state)}
                    {unitOfMeasure}
                    {props.bulkPurchaseLink}
                    {description}
                    {_renderTextBlock(props.slots.textBlocks)}
                    {rating}
                    {configure && _renderConfigure(configure)}
                    {keyInPrice && _renderKeyInPrice(keyInPrice)}
                    {quantity && _renderQuantity(quantity, callbacks, props, state, resources, quantityLimitsMessages, max, telemetryContent)}
                    {inventoryLabel}
                    {_renderCartAndActions(addToCart, addToOrderTemplate, addToWishlist)}
                    {findInStore && _renderFindInStore(findInStore)}
                    {_renderSocialShare(props.slots && props.slots.socialShare)}
                    {productComparisonButton}
                    {shopSimilarLook && _renderShopSimilarItem(shopSimilarLook)}
                    {shopSimilarDescription && _renderShopSimilarItem(shopSimilarDescription)}
                    {props.config.enableProductDocument && _renderProductDocument(productSpecificationData, props.config.documentHeading)}
                </Node>
            </Module>
            {props.config.enableProductDescription && _renderProductDescription(productSpecificationData, props.config.descriptionHeading)}
        </>
    );
}

const _renderProductNumber = (props: IBuyboxProps<IBuyboxData>, product?: SimpleProduct): JSX.Element | undefined => {
    return product && (props.context.app.config.showProductNumber || false) && <p className='ms-buybox__product-description'>{product.ItemId}</p>;
};

const _renderProductPrice = (props: IBuyboxViewProps & IBuyboxExtentionProps<IBuyboxExtentionData>, state: IBuyboxState): JSX.Element | undefined => {
    const { id, typeName, context, resources } = props;
    const hasProductDimensions = ArrayExtensions.hasElements(props.data.productDimensions?.result);
    let evetFreePlaceholder = props.context.app.config.enableFreeTextPlaceholder ? props.context.app.config.freeTextPlaceholder : resources.priceFree;
    if (((props.context.app.config.disablePriceForNotAuthorizedUser || false) && !props.context.request.user.isAuthenticated && (state.productPrice?.CustomerContextualPrice === undefined || state.productPrice?.CustomerContextualPrice >= 0) && (props.config.enableCustomPriceMessage || false))) {
        return <p className='ms-buybox__product-description'>{props.config.textMessageForNotLoggedInUser || ''}</p>;
    } else if (hasProductDimensions && (state.productPrice?.CustomerContextualPrice === undefined || state.productPrice?.CustomerContextualPrice === 0) && (props.context.app.config.enableCustomPriceMessage || false)) {
        let textMessageForMasterVariant: string = '';
        switch (props.context.request.locale.trim().toUpperCase()) {
            case 'EN-US':
                textMessageForMasterVariant = props.context.app.config.textMessageForMasterVariantEN || '';
                break;
            case 'DE':
                textMessageForMasterVariant = props.context.app.config.textMessageForMasterVariantDE || '';
                break;
            case 'DA':
                textMessageForMasterVariant = props.context.app.config.textMessageForMasterVariantDA || '';
                break;
            default:
                textMessageForMasterVariant = '';
                break;
        }

        return <p className='ms-buybox__product-description'>{textMessageForMasterVariant}</p>;
    } else {
        return (
            state.productPrice && (
                <PriceComponent
                    id={id}
                    typeName={typeName}
                    context={context}
                    data={{ price: state.productPrice }}
                    isPriceMinMaxEnabled={
                        props.data.featureState.result?.find(
                            featureState => featureState.Name === 'Dynamics.AX.Application.RetailSearchPriceRangeFeature'
                        )?.IsEnabled
                    }
                    isSalesAgreementPriceFeatureEnabled={
                        props.data.featureState.result?.find(
                            featureState => featureState.Name === 'Dynamics.AX.Application.RetailSalesAgreementPriceSupportFeature'
                        )?.IsEnabled
                    }
                    priceResources={{
                        priceRangeSeparator: resources.priceRangeSeparator,
                        salesAgreementPricePrompt: resources.salesAgreementPricePrompt,
                        salesAgreementExpirationDatePrompt: resources.salesAgreementExpirationDatePrompt,
                        salesAgreementCommittedQuantityPrompt: resources.salesAgreementCommittedQuantityPrompt,
                        salesAgreementRemainingQuantityPrompt: resources.salesAgreementRemainingQuantityPrompt
                    }}
                    freePriceText={evetFreePlaceholder}
                    originalPriceText={resources.originalPriceText}
                    currentPriceText={resources.currentPriceText}
                />
            )
        );
    }
};

const _renderTextBlock = (textBlocks: React.ReactNode[]): JSX.Element | undefined => {
    if (!textBlocks || textBlocks.length === 0) {
        return undefined;
    }

    return <>{textBlocks[0]}</>;
};

const _renderSocialShare = (socialShare: React.ReactNode[]): JSX.Element | undefined => {
    if (!socialShare || socialShare.length === 0) {
        return undefined;
    }

    return <>{socialShare[0]}</>;
};

const _renderCartAndActions = (
    addToCart?: IBuyboxAddToCartViewProps,
    addToOrderTemplate?: IBuyboxAddToOrderTemplateViewProps,
    addToWishlist?: IBuyboxAddToWishlistViewProps
): JSX.Element | undefined => {
    if (!addToCart && !addToWishlist) {
        return undefined;
    }

    return (
        <div className='product-add-to-cart'>
            {addToCart && addToCart.errorBlock}
            {addToOrderTemplate && addToOrderTemplate.errorBlock}
            {addToWishlist && addToWishlist.errorBlock}
            <div className='buttons'>
                {addToCart && addToCart.button}
                {addToOrderTemplate && addToOrderTemplate.button}
                {addToWishlist && addToWishlist.button}
            </div>
        </div>
    );
};

const _renderConfigure = (configure: IBuyboxProductConfigureViewProps): JSX.Element => {
    const { ContainerProps, dropdowns } = configure;

    return <Node {...ContainerProps}>{dropdowns.map(_renderConfigureDropdown)}</Node>;
};

const _renderConfigureDropdown = (dropdown: IBuyboxProductConfigureDropdownViewProps): JSX.Element => {
    const { ContainerProps, LabelContainerProps, heading, errors, select } = dropdown;

    return (
        <Node {...ContainerProps}>
            <Node {...LabelContainerProps}>
                {heading}
                {errors}
            </Node>
            {select}
        </Node>
    );
};

const _renderFindInStore = (findInStore: IBuyboxFindInStoreViewProps): JSX.Element => {
    const { ContainerProps, storeSelector, heading, description, errors, button, modal, productPickupOptionList } = findInStore;

    return (
        <Node {...ContainerProps}>
            {storeSelector}
            {heading}
            {productPickupOptionList}
            {description}
            {errors}
            {button}
            {modal}
        </Node>
    );
};

/**
 * On Change function.
 * @param callbacks -Callbacks.
 * @returns Update quantity.
 */
const onChangeHandler = (callbacks: IBuyboxCallbacks) => (newValue: number): boolean => {
    if (callbacks.updateQuantity) {
        return callbacks.updateQuantity(newValue);
    }
    return true;
};

const _renderQuantity = (
    quantityComponent: IBuyboxProductQuantityViewProps,
    callbacks: IBuyboxCallbacks,
    props: IBuyboxProps<IBuyboxData>,
    state: IBuyboxState,
    extentionResources: IBuyboxExtentionResources,
    quantityLimitsMessages: React.ReactNode,
    max: number | undefined,
    telemetryContent?: ITelemetryContent
): JSX.Element => {
    const { ContainerProps, LabelContainerProps, heading, errors } = quantityComponent;

    const { resources } = props;

    const { quantity } = state;

    return (
        <Node {...ContainerProps}>
            <Node {...LabelContainerProps}>
                {heading}
                {errors}
            </Node>

            <IncrementalQuantity
                id='ms-buybox__product-quantity-input'
                max={max}
                currentCount={quantity}
                onChange={onChangeHandler(callbacks)}
                inputQuantityAriaLabel={resources.inputQuantityAriaLabel}
                decrementButtonAriaLabel={extentionResources.decrementButtonAriaLabel}
                incrementButtonAriaLabel={extentionResources.incrementButtonAriaLabel}
                minQuantityText={extentionResources.minQuantityText}
                maxQuantityText={extentionResources.maxQuantityText}
                telemetryContent={telemetryContent}
            />
            {_renderQuantityLimitsMessages(props, quantityLimitsMessages)}
        </Node>
    );
};

export function _renderQuantityLimitsMessages(
    props: IBuyboxProps<IBuyboxData>,
    quantityLimitsMessages: React.ReactNode
): React.ReactNode | undefined {
    const maxQuantityForCartLineItem = props.context.app.config.maxQuantityForCartLineItem;
    if(maxQuantityForCartLineItem == undefined || maxQuantityForCartLineItem == 999999999999999)
    {
        return undefined;
    }
    else{
        return quantityLimitsMessages;
    }
}

const _renderKeyInPrice = (keyInPrice: IBuyboxKeyInPriceViewProps): JSX.Element => {
    const { ContainerProps, LabelContainerProps, heading, input } = keyInPrice;

    return (
        <Node {...ContainerProps}>
            <Node {...LabelContainerProps}>{heading}</Node>
            {input}
        </Node>
    );
};

const _renderShopSimilarItem = (shopSimilarItem: IBuyboxShopSimilarLookViewProps): JSX.Element => {
    const { ContainerProps, errors, input } = shopSimilarItem;

    return (
        <Node {...ContainerProps}>
            {errors}
            {input}
        </Node>
    );
};

const _renderProductDocument = (attributes?: AttributeValue[], heading?: string): JSX.Element | null => {
    let product =
        attributes &&
        ArrayExtensions.firstOrDefault(attributes?.filter(att => {
            return att.Name?.trim()?.toUpperCase()?.includes('document'.trim().toUpperCase());
        }));

    return (
        <>
            {<Msdyn365.Text className='ms-product-specification__heading' text={heading} />}
            {(product == null || product == undefined) || StringExtensions.isNullOrWhitespace(product?.TextValue) ? null : <span dangerouslySetInnerHTML={Msdyn365.getRichTextHtml(product.TextValue)} />}
        </>
    );
};

const _renderProductDescription = (attributes?: AttributeValue[], heading?: string): JSX.Element | null => {
    let product =
        attributes &&
        ArrayExtensions.firstOrDefault(attributes?.filter(att => {
            return att.Name?.trim()?.toUpperCase()?.includes('description'.trim().toUpperCase());
        }));

    return (
        <>
            {<Msdyn365.Text className='ms-product-specification__heading' text={heading} />}
            {(product == null || product == undefined) || StringExtensions.isNullOrWhitespace(product?.TextValue) ? null : <span dangerouslySetInnerHTML={Msdyn365.getRichTextHtml(product.TextValue)} />}
        </>
    );
};

export default BuyboxView;
